import { render, staticRenderFns } from "./StatistcGroups.vue?vue&type=template&id=378d5a5c&scoped=true&"
import script from "./StatistcGroups.vue?vue&type=script&lang=js&"
export * from "./StatistcGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d5a5c",
  null
  
)

export default component.exports